 // tslint:disable: variable-name

import { OverlayRef } from '@angular/cdk/overlay';
import { SheetContainer } from './sheet-container.component';
import { Subject, Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

export class SheetRef {
  public componentInstance: SheetContainer;

  private _beforeClose = new Subject<any | undefined>();
  private _afterClosed = new Subject<any | undefined>();

  private _result: any | undefined;

  constructor(private overlayRef: OverlayRef) { }

  public close(data?: any): void {
    this._result = data;

    // Listen for animation 'start' events
    this.componentInstance.animationStateChanged.pipe(
      filter(event => event.phaseName === 'start'),
      take(1)
    ).subscribe(() => {
      this._beforeClose.next(this._result);
      this._beforeClose.complete();
      this.overlayRef.detachBackdrop();
    });

    // Listen for animation 'done' events
    this.componentInstance.animationStateChanged.pipe(
      filter(event => event.phaseName === 'done' && event.toState === 'leave'),
      take(1)
    ).subscribe(() => {
      this._afterClosed.next(this._result);
      this._afterClosed.complete();
      this.overlayRef.dispose();

      // Make sure to also clear the reference to the
      // component instance to avoid memory leaks
      // tslint:disable-next-line: no-non-null-assertion
      this.componentInstance = null!;
    });

    // Start exit animation
    this.componentInstance.startExitAnimation();
  }

  public afterClosed(): Observable<any | undefined> {
    return this._afterClosed.asObservable();
  }

  public beforeClose(): Observable<any | undefined> {
    return this._beforeClose.asObservable();
  }
}
